import React from 'react';

import PaymentStatusBadge from '~direct-debits/components/payment-batches/PaymentStatusBadge';
import { PaymentBatchClient } from '~direct-debits/models';

interface ComponentProps {
  row: PaymentBatchClient;
}

// Adapter cell — the level-2 clients-in-batch table reads a row's
// `payment_status` field, but the shared badge component reads `row.status`.
// This thin wrapper keeps the badge contract stable and the column definition
// declarative.
//
// A refunded line keeps its factual payment status (it WAS paid out) and gains
// a parallel "Refunded · DDR-…" note — the refund is a separate lifecycle, not
// a replacement of the payment status (TAV-2833).
const BatchClientPaymentStatusCell: React.FC<ComponentProps> = ({ row }) => (
  <div className="d-flex flex-column align-items-center gap-1">
    <PaymentStatusBadge status={row.payment_status} />
    {row.refund && (
      <span className="small text-muted" data-cy={`dd-payment-batch-refund-chip-${row.client_id}`}>
        ↩ Refunded · {row.refund.reference}
      </span>
    )}
  </div>
);

export default BatchClientPaymentStatusCell;
